import React, { Suspense } from 'react'
import { SupplierOnlineManagementForm } from './styled'
import {
  Button,
  Modal,
  Section,
  InputTextarea,
  Checkbox,
  InputUpload,
  Image,
  Loading,
  Loaders,
  AttachedFile,
} from '../../components'

import { supplierManagementController } from '../../apiService'
import { ICONS } from '../../themes'
import {
  STRING,
  ROUTE_PATH,
  toastFail,
  dateMonDayYearTime,
  toastActive,
  localStorageService,
} from '../../helpers'
import { Line } from 'rc-progress'
import FileDownload from 'js-file-download'
import { store } from '../../store'
import { logout } from '../../store/actions'

export class SupplierOnlineManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      onlineByID: '',
      onlineComprehensive: '',
      sections: [],
      sectionIndex: 0,
      checkValidate: false,
      userId: localStorageService.getBuyerId(),
      supplierId: '',
      modal: '',
      display: false,
      onlineSupplierAnswer: [],
      fromMail: false,
      loadingDownloadFile: [],
    }
  }

  componentDidMount = async () => {
    if (this.props.location.state && this.props.location.state.id) {
      this.getTemplateByID(this.props.location.state.id)
      this.setState({ supplierId: this.props.location.state.supplierId })
    } else {
      if (this.props.match.params && this.props.match.params.templateId) {
        if (
          this.props.match.params.requestDate &&
          this.props.match.params.requestDate === 'display'
        ) {
          this.setState({
            fromMail: false,
            display: true,
            supplierId: this.props.match.params.supplierId,
          })
          this.getTemplateByID(this.props.match.params.templateId)
        } else {
          console.log(this.props.match.params)
          if (
            this.props.match.params.supplierId ==
            localStorageService.getBuyerId()
          ) {
            this.checkLink(
              this.props.match.params.templateId,
              this.props.match.params.supplierId,
              this.props.match.params.requestDate
            )
            // this.setState({ fromMail: true })
            // this.setState({ supplierId: this.props.match.params.supplierId })
            // this.getTemplateByID(this.props.match.params.templateId)
          } else {
            toastFail('Unauthorized access')
            store.dispatch(logout())
          }
        }
      } else {
        this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK)
      }
    }
  }

  checkLink = async (tempalteId, supplierId, requestDate) => {
    console.log(tempalteId, supplierId, requestDate)
    const res = await supplierManagementController().checkLink(
      tempalteId,
      supplierId,
      requestDate
    )
    // console.log('checkLink', res)
    if (res) {
      if (res === '4006: supplier id not found') {
        toastFail('supplier id not found')
        this.props.history.push('/')
      } else {
        if (res.data && !res.data.result) {
          toastFail('Link Expired')
          this.props.history.push('/')
        } else {
          this.setState({ fromMail: true })
          this.setState({ supplierId: supplierId })
          this.getTemplateByID(tempalteId)
        }
      }
    } else {
      toastFail('Link Expired')
      this.props.history.push('/')
    }
  }

  getTemplateByID = async id => {
    this.setState({ isLoading: true })
    const res = await supplierManagementController().getOnlineTemplateID(id)
    // console.log('getTemplateByID', res)
    if (res) {
      if (res === 'record not found') {
        toastFail('Link Expired')
        this.props.history.push('/')
      } else {
        if (this.props.match.params && this.props.match.params.templateId) {
          this.getOnlineByID(
            this.props.match.params.templateId,
            this.props.match.params.supplierId
          )
        }
        if (this.props.location.state && this.props.location.state.id) {
          this.getOnlineByID(
            this.props.location.state.id,
            this.props.location.state.supplierId
          )
        }
        this.setState({
          onlineByID: res,
          sections: res.online_template_section,
        })
        if (this.state.display) {
          this.getRespond(id, this.state.supplierId)
        }
      }
    } else {
      this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK)
    }
    this.setState({ isLoading: false })
  }

  getOnlineByID = async (templateId, supplierId) => {
    const res = await supplierManagementController().getOnlineComprehensiveID(
      templateId,
      supplierId
    )
    // console.log('getOnlineComprehensiveID', res)
    if (res) {
      if (this.state.fromMail && res.updated_by !== 0) {
        this.setState({ modal: 'responded', display: true })
        this.getRespond(templateId, supplierId)
      }
      this.setState({ onlineComprehensive: res })
    } else {
      this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK)
    }
  }

  getRespond = async (templateId, supplierId) => {
    const res = await supplierManagementController().getRespond(
      templateId,
      supplierId
    )
    // console.log('getRespond', res)
    if (res) {
      await this.setState({ onlineSupplierAnswer: res.online_supplier_answer })
      this.setAnswer()
    } else {
      console.error('error')
    }
  }

  setAnswer() {
    const { sections, onlineSupplierAnswer } = this.state
    let newSections = [...sections]
    newSections.map((s, sIndex) => {
      s.isDone = true
      s.online_template_question_group.map((g, gIndex) => {
        g.online_template_question.map((q, qIndex) => {
          onlineSupplierAnswer.map((a, aIndex) => {
            if (q.id === a.question_id) {
              q.answer = a.answer ? 'yes' : 'no'
              q.comment = a.comment
              q.files = a.online_supplier_answer_file || []
              q.answerId = a.id
            }
          })
        })
      })
    })
    // console.log('newSections', newSections)
    this.setState({ sections: newSections })
  }

  renderSection() {
    const { onlineByID, sections, sectionIndex } = this.state
    const section = sections[sectionIndex]
    return (
      <>
        <Section className="section-header">
          <div className="section-no">Section {sectionIndex + 1}:</div>
          <div className="section-title">
            <h4>{section.name}</h4>
            <small>{section.description}</small>
          </div>
        </Section>
        {section.online_template_question_group.map((item, index) =>
          this.renderGroup(section, item, index)
        )}
      </>
    )
  }

  renderGroup(section, data, gIndex) {
    return (
      <Section
        className="card"
        key={'group' + this.state.sectionIndex + gIndex}
      >
        <Section className="card-title">
          <span>
            {this.state.sectionIndex + 1}.{gIndex + 1}:
          </span>
          {data.name || '-'}
        </Section>
        <Section className="card-body">
          <ul>
            {data.online_template_question.map((item, index) => {
              // console.log(index, item)
              return this.renderQuestion(
                section,
                item,
                gIndex,
                index,
                data.is_required
              )
            })}
          </ul>
        </Section>
      </Section>
    )
  }

  fileUpload(file, data, cb, gIndex, index) {
    const { sectionIndex, sections } = this.state
    let dataFiles = Array.isArray(data.files) ? [...data.files] : []
    dataFiles.push({
      id: '',
      name: file.name,
      files: file,
    })
    data = { ...data, files: dataFiles }

    sections[sectionIndex].online_template_question_group[
      gIndex
    ].online_template_question[index] = data

    this.setState({ sections: sections }, cb)
  }

  renderQuestion(section, data, gIndex, index, isRequired) {
    const { checkValidate } = this.state

    let answers = data.answer || 'yes'
    let isAnswerError =
      !data.answer && checkValidate && isRequired ? true : false
    let isCommentError = false
    if (
      data.required_to_add_comment &&
      isRequired &&
      (answers === 'yes' || answers === 'no')
    ) {
      if (checkValidate && !data.comment) {
        isCommentError = true
      }
    }
    let isAttachmentError = false
    if (
      data.required &&
      isRequired &&
      (answers === 'yes' || answers === 'no')
    ) {
      if (checkValidate && !data.files) {
        isAttachmentError = true
      }
    }
    let isCommentOrAttachmentError = false
    if (
      data.required_to_add_comment_or_file &&
      isRequired &&
      (answers === 'yes' || answers === 'no')
    ) {
      if (checkValidate && !data.comment && !data.files) {
        isCommentOrAttachmentError = true
      }
    }
    let isError =
      checkValidate &&
      (isAnswerError ||
        isCommentError ||
        isAttachmentError ||
        isCommentOrAttachmentError)

    return (
      <li key={'question' + this.state.sectionIndex + gIndex + index}>
        <Section isError={isError} className="sub-heading">
          <div>
            <span>
              {this.state.sectionIndex + 1}.{gIndex + 1}.{index + 1}:{' '}
            </span>
            {data.question}
          </div>
          {!isRequired && (
            <Button
              className="theme-blue btn-height-32"
              onClick={() => {
                data.answer = ''
                data.isAnswer = true
                let newSection = [...this.state.sections]
                let newGroup = [
                  ...newSection[this.state.sectionIndex]
                    .online_template_question_group,
                ]
                newGroup[gIndex].online_template_question[index] = data
                newSection[
                  this.state.sectionIndex
                ].online_template_question_group = newGroup
                this.setState({ sections: newSection })
              }}
            >
              Clear
            </Button>
          )}
        </Section>
        <div className="sub-body">
          <Section isError={isAnswerError} className="checkbox-group">
            <Checkbox
              disabled={this.state.display}
              className="is-radio-type"
              id={'answerYes' + this.state.sectionIndex + gIndex + index}
              key={'answerYes' + this.state.sectionIndex + gIndex + index}
              checked={data.answer === 'yes'}
              onChange={e => {
                data.answer = 'yes'
                data.isAnswer = true
                let newSection = [...this.state.sections]
                let newGroup = [
                  ...newSection[this.state.sectionIndex]
                    .online_template_question_group,
                ]
                newGroup[gIndex].online_template_question[index] = data
                newSection[
                  this.state.sectionIndex
                ].online_template_question_group = newGroup
                this.setState({ sections: newSection })
              }}
            >
              Yes
            </Checkbox>
            <Checkbox
              disabled={this.state.display}
              className="is-radio-type"
              id={'answerNo' + this.state.sectionIndex + gIndex + index}
              key={'answerNo' + this.state.sectionIndex + gIndex + index}
              checked={data.answer === 'no'}
              onChange={() => {
                data.answer = 'no'
                data.isAnswer = true
                let newSection = [...this.state.sections]
                let newGroup = [
                  ...newSection[this.state.sectionIndex]
                    .online_template_question_group,
                ]
                newGroup[gIndex].online_template_question[index] = data
                newSection[
                  this.state.sectionIndex
                ].online_template_question_group = newGroup
                this.setState({ sections: newSection })
              }}
            >
              No
            </Checkbox>
          </Section>
          <p>{data.requirement}</p>
          {this.state.display ? (
            data.comment &&
            data.comment !== '' && (
              <Section
                isError={
                  isCommentError || isCommentOrAttachmentError ? true : false
                }
                mb={'1rem'}
                className="form-group"
              >
                <label>Comment</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={data.comment}
                      placeholder="provide a copy of supporting documentation or a brief description of such standards or requirements"
                    />
                  </Section>
                </Section>
              </Section>
            )
          ) : (
            <Section
              isError={
                isCommentError || isCommentOrAttachmentError ? true : false
              }
              mb={'1rem'}
              className="form-group"
            >
              <label>Comment</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    disabled={this.state.display}
                    value={data.comment}
                    onChange={e => {
                      data.comment = e.target.value
                      data.isComment = true
                      let newSection = [...this.state.sections]
                      let newGroup = [
                        ...newSection[this.state.sectionIndex]
                          .online_template_question_group,
                      ]
                      newGroup[gIndex].online_template_question[index] = data
                      newSection[
                        this.state.sectionIndex
                      ].online_template_question_group = newGroup
                      this.setState({ sections: newSection })
                    }}
                    placeholder="provide a copy of supporting documentation or a brief description of such standards or requirements"
                  />
                </Section>
                {/* <Section className="message"></Section> */}
              </Section>
            </Section>
          )}
          {this.state.display
            ? data.files &&
              data.files.length > 0 && (
                <Section isError={isAttachmentError} className="form-group">
                  <label className="tooltip-upload">
                    Attachment
                    <Section className="link tooltip-attachment">
                      <Image
                        src={
                          isAttachmentError
                            ? ICONS['icon-help-error.svg']
                            : ICONS['icon-help.svg']
                        }
                        alt="help"
                        tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                        useTootipFor="FileType"
                        useTootip={true}
                      />
                    </Section>
                  </label>
                  <Section className="form-group-control">
                    {Array.isArray(data.files)
                      ? data.files.map((item, i) => (
                          <Section
                            className="attached-file-list"
                            key={
                              'file' +
                              this.state.sectionIndex +
                              gIndex +
                              index +
                              i
                            }
                          >
                            <a
                              className="file-link removable"
                              onClick={() => {
                                this.state.loadingDownloadFile.push({
                                  id: item.id,
                                })
                                this.setState({
                                  loadingDownloadFile: this.state
                                    .loadingDownloadFile,
                                })
                                this.downloadFileAnswer(item)
                              }}
                            >
                              {/* <a onClick={() => {}}> */}
                              <span className="file-name">{item.name}</span>
                              {/* </a> */}
                            </a>
                            {this.renderDownloadFile(item)}
                          </Section>
                        ))
                      : null}
                  </Section>
                </Section>
              )
            : (data.required || data.required_to_add_comment_or_file) && (
                <>
                  {!this.state.display && (
                    <Section
                      isError={
                        isAttachmentError || isCommentOrAttachmentError
                          ? true
                          : false
                      }
                      className="form-group"
                    >
                      <label className="tooltip-upload">
                        Attachment
                        <Section className="link tooltip-attachment">
                          <Image
                            src={
                              isAttachmentError || isCommentOrAttachmentError
                                ? ICONS['icon-help-error.svg']
                                : ICONS['icon-help.svg']
                            }
                            alt="help"
                            tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                            useTootipFor="FileType"
                            useTootip={true}
                          />
                        </Section>
                      </label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper ">
                          <AttachedFile
                            index={index}
                            id={'upload' + gIndex + '_' + index}
                            name={'upload' + gIndex + '_' + +index}
                            onSelect={(file, e, cb) => {
                              if (file) {
                                // this.fileUpload(file, data, cb, gIndex, index)
                                const dataFile = {
                                  name: file.name,
                                  files: file,
                                }
                                this.uploadFile(
                                  dataFile,
                                  data,
                                  cb,
                                  gIndex,
                                  index
                                )
                              }
                            }}
                          />
                        </Section>
                        <Section className="message"></Section>
                      </Section>
                    </Section>
                  )}
                  {data.files && (
                    <Section isError={isAttachmentError} className="form-group">
                      {this.state.display && (
                        <label className="tooltip-upload">
                          Attachment
                          <Section className="link tooltip-attachment">
                            <Image
                              src={
                                isAttachmentError
                                  ? ICONS['icon-help-error.svg']
                                  : ICONS['icon-help.svg']
                              }
                              alt="help"
                              tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                              useTootipFor="FileType"
                              useTootip={true}
                            />
                          </Section>
                        </label>
                      )}
                      <Section className="form-group-control">
                        {Array.isArray(data.files)
                          ? data.files.map((item, i) => (
                              <Section
                                className="attached-file-list"
                                key={
                                  'file' +
                                  this.state.sectionIndex +
                                  gIndex +
                                  index +
                                  i
                                }
                              >
                                <a className="file-link removable">
                                  {/* <a onClick={() => {}}> */}
                                  <span
                                    className="file-name"
                                    onClick={() => {
                                      this.state.loadingDownloadFile.push({
                                        id: item.id,
                                      })
                                      this.setState({
                                        loadingDownloadFile: this.state
                                          .loadingDownloadFile,
                                      })
                                      this.downloadFileAnswer(item)
                                    }}
                                  >
                                    {item.name}
                                  </span>
                                  {/* </a> */}
                                  {!this.state.display && (
                                    <Button
                                      className="link"
                                      onClick={() => {
                                        let dataFiles = data.files
                                          ? [...data.files]
                                          : []
                                        dataFiles.splice(i, 1)
                                        data.files = dataFiles
                                        let newSection = [
                                          ...this.state.sections,
                                        ]
                                        let newGroup = [
                                          ...newSection[this.state.sectionIndex]
                                            .online_template_question_group,
                                        ]
                                        newGroup[
                                          gIndex
                                        ].online_template_question[index] = data
                                        newSection[
                                          this.state.sectionIndex
                                        ].online_template_question_group = newGroup
                                        this.setState({ sections: newSection })
                                      }}
                                    >
                                      <Image
                                        className="delete-circle-icon delete_company_profile"
                                        src={
                                          ICONS['icon-delete-circle-red.svg']
                                        }
                                        alt="delete circle"
                                      />
                                    </Button>
                                  )}
                                </a>
                                {this.renderDownloadFile(item)}
                              </Section>
                            ))
                          : null}
                      </Section>
                    </Section>
                  )}
                </>
              )}
          <Section isError={true} className="section-text-error">
            {isCommentError && <span>This question requires an comment.</span>}
            {isAttachmentError && (
              <span>This question requires an attachment.</span>
            )}
            {isCommentOrAttachmentError && (
              <span>
                This Question is required to add comment or attach file.
              </span>
            )}
          </Section>
        </div>
      </li>
    )
  }

  checkValidate() {
    const { sections, sectionIndex } = this.state
    const groups = sections[sectionIndex].online_template_question_group
    let isDone = true
    for (var gIndex = 0; gIndex < groups.length; gIndex++) {
      const questions = groups[gIndex].online_template_question
      // console.log(groups[gIndex])
      if (groups[gIndex].is_required) {
        for (var qIndex = 0; qIndex < questions.length; qIndex++) {
          if (!questions[qIndex].answer || questions[qIndex].answer === '') {
            isDone = false
          } else {
            if (
              questions[qIndex].answer === 'yes' ||
              questions[qIndex].answer === 'no'
            ) {
              if (questions[qIndex].required_to_add_comment) {
                if (
                  !questions[qIndex].comment ||
                  questions[qIndex].comment === ''
                ) {
                  isDone = false
                }
              }
              if (questions[qIndex].required) {
                if (!questions[qIndex].files) {
                  isDone = false
                }
              }

              if (questions[qIndex].required_to_add_comment_or_file) {
                if (
                  (!questions[qIndex].comment ||
                    questions[qIndex].comment === '') &&
                  !questions[qIndex].files
                ) {
                  isDone = false
                }
              }
            }
          }
        }
      }
    }
    return isDone
  }

  onSubmit = async () => {
    const { sections, onlineByID, userId } = this.state
    // console.log(sections)
    let onlineSupplierAnswer = []
    for (var sIndex = 0; sIndex < sections.length; sIndex++) {
      const groups = sections[sIndex].online_template_question_group || []
      for (var gIndex = 0; gIndex < groups.length; gIndex++) {
        const questions = groups[gIndex].online_template_question || []
        for (var qIndex = 0; qIndex < questions.length; qIndex++) {
          // let questionFile = []
          // const file = questions[qIndex].files || []
          // if (file.length > 0) {
          //   for (var fIndex = 0; fIndex < file.length; fIndex++) {
          //     let uploadFile = await this.uploadFile(file[fIndex])
          //     if (uploadFile === false) {
          //       return false
          //     }
          //     questionFile.push(uploadFile)
          //   }
          // }
          onlineSupplierAnswer.push({
            id: '',
            answer: questions[qIndex].answer === 'yes' ? true : false,
            comment: questions[qIndex].comment || '',
            question_id: questions[qIndex].id,
            supplier_response_id: userId,
            online_supplier_answer_file: questions[qIndex].files,
          })
        }
      }
    }
    let data = {
      template_id: onlineByID.id,
      supplier_id: parseInt(userId),
      online_supplier_answer: onlineSupplierAnswer,
    }
    // console.log('data', data)
    try {
      const res = await supplierManagementController().addOnlineRespond(data)
      // console.log('addOnlineRespond', res)

      if (res) {
        if (res === 'Complete the questionnaire') {
          toastActive('Response questionnaire successfully')
          this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK)
        } else {
          toastFail(res)
        }
      } else {
        toastFail('Error')
      }
    } catch (e) {
      console.log(e)
    }
    this.setState({ isLoading: false })
  }

  uploadFile = async (file, data, cb, gIndex, index) => {
    const { sectionIndex, sections } = this.state
    try {
      let response = ''
      let formData = new FormData()
      formData.append('name', file.name)
      formData.append('file', file.files)
      const res = await supplierManagementController().upLoadFileOnlineRespond(
        formData
      )
      // console.log(res)
      if (res) {
        response = {
          id: res.id,
          name: res.name,
          is_deleted: false,
        }
        let dataFiles = Array.isArray(data.files) ? [...data.files] : []
        dataFiles.push(response)
        data = { ...data, files: dataFiles }

        sections[sectionIndex].online_template_question_group[
          gIndex
        ].online_template_question[index] = data

        this.setState({ sections: sections }, cb)
      }
      return response
    } catch (e) {
      this.setState({ isLoading: false })
      return false
    }
  }

  countPercent() {
    const { sections } = this.state
    let countDone = 0
    for (var sIndex = 0; sIndex < sections.length; sIndex++) {
      if (sections[sIndex].isDone) {
        countDone = countDone + 1
      }
    }
    let percent = parseFloat((countDone / sections.length) * 100).toFixed(2)
    return percent
  }

  rederBusinessType(data) {
    // console.log(data)
    let businessType = ''
    data.map((btg, btgIndex) => {
      if (btgIndex === data.length - 1) {
        businessType = businessType + btg.business_type
      } else {
        businessType = businessType + btg.business_type + ','
      }
    })
    if (businessType === '') {
      businessType = '-'
    }
    return businessType
  }

  downloadAttachment = () => {
    const { onlineByID } = this.state
    const files = onlineByID.online_template_file || []

    const funcDownloadFile = async file => {
      try {
        const dataFile = await supplierManagementController().downloadTempalteFile(
          file.id
        )
        // console.log(dataFile)
        const { data } = dataFile
        FileDownload(data, file.name)
      } catch (error) {
        console.log(error)
      }
    }

    if (files.length > 0) {
      // console.log(files)
      for (var i = 0; i < files.length; i++) {
        funcDownloadFile(files[i])
      }
    }
  }

  downloadFileAnswer = async file => {
    //console.log(file)
    const { loadingDownloadFile } = this.state
    if (file.id !== '') {
      try {
        const dataFile = await supplierManagementController().downloadFileAnswer(
          file.id
        )
        const { data } = dataFile
        FileDownload(data, file.name)
        let index = loadingDownloadFile.findIndex(x => x.id === file.id)
        loadingDownloadFile.splice(index, 1)
        this.setState({
          loadingDownloadFile: loadingDownloadFile,
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      FileDownload(file.files, file.name)
    }
  }

  renderDownloadFile = file => {
    const { loadingDownloadFile } = this.state
    return (
      loadingDownloadFile &&
      loadingDownloadFile.map((value, index) => {
        if (value.id === file.id) {
          return (
            <Loaders
              load={true}
              key={index}
              style={
                {
                  // marginLeft: '-35px',
                  // position: 'relative',
                  // right: '-75px',
                }
              }
            />
          )
        }
      })
    )
  }

  render() {
    const {
      onlineByID,
      sections,
      sectionIndex,
      onlineComprehensive,
    } = this.state
    return (
      <React.Fragment>
        <SupplierOnlineManagementForm>
          <Section className="main-content">
            <Section className="page-topbar flex-column">
              <Section mb={'1rem'} className="page-header">
                <Section className="page-icon">
                  <Image
                    src={ICONS['icon-comprehensive- assessment.svg']}
                    alt="page icon"
                  />
                </Section>

                <Section className="title-and-breadcrumb">
                  <Section className="title">
                    {STRING.SUPPLIER_ONLINE_COMPREHENSIVE_ASSESSMENT_MANAGEMENT}
                  </Section>
                </Section>
              </Section>
              <ul>
                <li>
                  <span>Questionnaire Version :</span>
                  <span>
                    {(onlineComprehensive !== '' &&
                      dateMonDayYearTime(
                        onlineComprehensive.questionnaire_version
                      )) ||
                      '-'}
                  </span>
                </li>
                <li>
                  <span>Requested date :</span>
                  <span>
                    {(onlineComprehensive !== '' &&
                      onlineComprehensive.is_send_mail &&
                      dateMonDayYearTime(onlineComprehensive.requested_date)) ||
                      '-'}
                  </span>
                </li>
                <li>
                  <span>Response date :</span>
                  <span>
                    {onlineComprehensive !== '' &&
                    onlineComprehensive.updated_by_string !== '' &&
                    onlineComprehensive.response_date
                      ? dateMonDayYearTime(onlineComprehensive.response_date)
                      : '-'}
                  </span>
                </li>
                <li>
                  <span>By :</span>
                  <span>
                    {(onlineComprehensive !== '' &&
                      onlineComprehensive.updated_by_string) ||
                      '-'}
                  </span>
                </li>
              </ul>
            </Section>

            <Section mb={'2rem'} className="content-body">
              <Section className="btn-download">
                <Button
                  disabled={
                    this.state.onlineByID !== '' &&
                    this.state.onlineByID.online_template_file &&
                    this.state.onlineByID.online_template_file.length > 0
                      ? false
                      : true
                  }
                  onClick={() => {
                    this.downloadAttachment()
                  }}
                >
                  Download template
                </Button>
              </Section>
              <Section className="form-wrapper flex-column">
                <h2>{onlineByID.name}</h2>
                <sub>{onlineByID.description}</sub>
                <Section>
                  <div className="section-no">
                    <label> Business Type :</label>
                  </div>
                  <div className="business-type">
                    {onlineByID !== '' &&
                      onlineByID.online_business_type_group.map((item, i) => {
                        return (
                          <div key={'btg' + i}>
                            {i + 1}.
                            {this.rederBusinessType(item.online_business_type)}
                          </div>
                        )
                      })}
                  </div>
                </Section>
              </Section>
            </Section>
            <Section className="content-body border-radius-6">
              {onlineByID !== '' && this.renderSection()}

              <Section pb={'2rem'} mr={'2rem'} className="form-actions">
                {sectionIndex == 0 && (
                  <Button
                    id=""
                    className="theme-solid-blue"
                    onClick={() => {
                      this.props.history.push(
                        ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK
                      )
                    }}
                  >
                    Cancel
                  </Button>
                )}

                {sectionIndex > 0 && (
                  <Button
                    id=""
                    className="theme-solid-blue"
                    onClick={() => {
                      this.setState({
                        checkValidate: false,
                        sectionIndex: sectionIndex - 1,
                      })
                    }}
                  >
                    Back
                  </Button>
                )}

                {sectionIndex + 1 < sections.length && (
                  <Button
                    id=""
                    className="theme-green"
                    onClick={() => {
                      this.setState({ checkValidate: true })
                      let isDone = this.checkValidate()
                      if (this.state.display) {
                        this.setState({
                          checkValidate: false,
                          sectionIndex: sectionIndex + 1,
                        })
                      } else {
                        if (isDone) {
                          let newSection = [...sections]
                          newSection[sectionIndex].isDone = true
                          this.setState({
                            checkValidate: false,
                            sections: newSection,
                            sectionIndex: sectionIndex + 1,
                          })
                        } else {
                          toastFail('This question is required')
                        }
                      }
                    }}
                  >
                    Next
                  </Button>
                )}
                {sectionIndex + 1 == sections.length && !this.state.display && (
                  <Button
                    id=""
                    className="theme-green"
                    onClick={() => {
                      this.setState({ checkValidate: true })
                      let isDone = this.checkValidate()
                      if (isDone) {
                        let newSection = [...sections]
                        newSection[sectionIndex].isDone = true
                        this.setState({
                          checkValidate: false,
                          sections: newSection,
                          modal: 'confirm',
                        })
                        // this.onSubmit()
                      } else {
                        toastFail('This question is required')
                      }
                    }}
                  >
                    Submit
                  </Button>
                )}
              </Section>
            </Section>
          </Section>

          <div className="step-progress">
            <ul className="step-progress-items">
              {sections.map((item, index) => (
                <li
                  className={
                    item.isDone &&
                    index !== sectionIndex &&
                    sections.length - 1 !== index
                      ? 'step-progress-item is-done'
                      : item.isDone &&
                        index !== sectionIndex &&
                        sections.length - 1 === index
                      ? 'step-progress-item step-last-done'
                      : index === sectionIndex &&
                        sections.length - 1 !== sectionIndex
                      ? 'step-progress-item is-current'
                      : sections.length - 1 === sectionIndex
                      ? 'step-progress-item step-last-current'
                      : 'step-progress-item'
                  }
                  key={'step' + index}
                  onClick={() => {
                    if (item.isDone || this.state.display) {
                      this.setState({
                        checkValidate: false,
                        sectionIndex: index,
                      })
                    }
                  }}
                >
                  <div>Section {index + 1}</div>
                  <div>{item.name}</div>
                </li>
              ))}
            </ul>
            <div className="step-progress-items">
              <div className="step-line-wrapper">
                <Line
                  percent={this.countPercent()}
                  strokeWidth={4}
                  trailWidth={4}
                  trailColor="#F4F4F4"
                  strokeColor="#29CC6A"
                />
                <span>{this.countPercent()}%</span>
              </div>
            </div>
          </div>

          <Modal
            id="confirm"
            className="theme-blue"
            classNameContainer="widthModal"
            isOpen={this.state.modal == 'confirm'}
            modalWidth="575px"
          >
            <Modal.Header>Submit</Modal.Header>
            <Modal.Body>
              <p className="default text-center">
                Are you sure to response questionnaire ?
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => this.setState({ modal: '' })}
                className="theme-border-gray"
              >
                Cancel
              </Button>
              <Button
                className="theme-green"
                onClick={() => {
                  this.setState({ modal: '', isLoading: true })
                  this.onSubmit()
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            id="confirm"
            className="theme-blue"
            classNameContainer="widthModal"
            isOpen={this.state.modal == 'responded'}
            modalWidth="575px"
          >
            <Modal.Header>Questionnaire Update Already</Modal.Header>
            <Modal.Body>
              <p className="default text-center">
                Do you want to view last update ?
              </p>
              <br />
              <p className="text-center">
                Response update :{' '}
                {(onlineComprehensive !== '' &&
                  dateMonDayYearTime(onlineComprehensive.response_date)) ||
                  '-'}
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  this.setState({ modal: '' })
                  this.props.history.push('/home')
                }}
                className="theme-border-gray"
              >
                Cancel
              </Button>
              <Button
                className="theme-green"
                onClick={() => {
                  this.setState({ modal: '' })
                }}
              >
                Display
              </Button>
            </Modal.Footer>
          </Modal>
        </SupplierOnlineManagementForm>
        <Loading loading={this.state.isLoading} />
      </React.Fragment>
    )
  }
}
